import { Button, Card, Col, Input, Radio, Row, Typography } from "antd";
import SubDefaultLayout from "../../components/SubDefaultLayout";
import { StyleSheet } from "../../StyleSheet";
import InfoCardComponent from "../../components/InfoCardComponent";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fillGeneralDataSlice,
  getGeneralData,
} from "../../stores/slices/generalDataSlice";
import {
  AlertSliceInterface,
  clearAlert,
  setAlert,
  showAlert,
} from "../../stores/slices/alertSlice";
import { AppDispatch } from "../../stores/store";
import _ from "lodash";
import {
  RequestAddCodeUpdateSuscriptor,
  RequestUpdateSuscriptor,
} from "../../types/common";
import {
  sendCodeUpdateSuscriptor,
  updateSuscriptor,
} from "../../methods/Methods";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import { getConfigurableServiceState } from "../../stores/slices/configurableServicesSlice";
const { Text } = Typography;

interface errorFieldsProps {
  cellphoneNumber?: string;
  emailAddress?: string;
  verificationCode?: string;
}

const UpdateSuscriptorData = () => {
  const generalData = useSelector(getGeneralData);
  const [cellphone, setCellPhone] = useState<string>("");
  const [code, setCode] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [idCliente, setIdCliente] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [askForCode, setAskForCode] = useState(false);
  const emptyErrorFields: errorFieldsProps = {
    cellphoneNumber: "",
    emailAddress: "",
    verificationCode: "",
  };
  const [selectedOption, setSelectedOption] = useState("cellphone");
  const [errorsEmptyFields, setErrorsEmptyFields] =
    useState<errorFieldsProps>(emptyErrorFields);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const confService = useSelector(getConfigurableServiceState);
  const updateDataServices =
    confService?.dataList?.filter((service) =>
      service.name.startsWith("DAF_UPDATE_DATA_"),
    ) ?? [];

  const updateDataServicesMap = Object.fromEntries(
    updateDataServices.map((service) => [service.name, service.enabled]),
  );

  const canUpdateEmail = !!updateDataServicesMap["DAF_UPDATE_DATA_EMAIL"];
  const canUpdatePhone = !!updateDataServicesMap["DAF_UPDATE_DATA_CELLPHONE"];

  const options: any["options"] = [
    { label: "Teléfono celular", value: "cellphone" },
    { label: "Correo electrónico", value: "email" },
  ];

  useEffect(() => {
    if (generalData.selectedContract !== null) {
      setIdCliente(
        generalData.selectedContract.sucursal +
          generalData.selectedContract.suscriptor,
      );
      setAskForCode(false);
      setCellPhone("");
      setCode("");
      setEmail("");
    }
  }, [generalData]);

  const handleDispatchAlertModal = useCallback(
    (navigateTo: string | null) => {
      dispatch(showAlert(false));
      dispatch(clearAlert());
      if (!_.isNull(navigateTo)) {
        navigate(navigateTo);
      }
    },
    [dispatch, navigate],
  );

  // Manejador para el alert
  const openAlertModal = useCallback(
    (option: AlertSliceInterface) => {
      dispatch(
        setAlert({
          show: option.show,
          type: option.type as "INFO" | "SUCCESS" | "ERROR",
          title: option.title,
          message: option.message,
          onFinalize: option.onFinalize,
        }),
      );
    },
    [dispatch],
  );

  const handleChangePhone = (value: string) => {
    errorsEmptyFields.cellphoneNumber = "";
    setCellPhone(value.replace(/[^0-9]/g, ""));
  };

  const handleChangeCode = (value: string) => {
    errorsEmptyFields.verificationCode = "";
    setCode(value.replace(/[^0-9]/g, ""));
  };

  const handleChangeEmail = (value: string) => {
    errorsEmptyFields.emailAddress = "";
    setEmail(value);
  };

  const handleOptionChange = (value: string) => {
    setSelectedOption(value);
    setErrorsEmptyFields(emptyErrorFields);
  };

  const validateEmail = (inputString: string) => {
    let valid = false;
    var reg = RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+.([a-zA-Z]{2,4})+$");
    var result = reg.test(inputString);
    if (result) {
      valid = true;
    } else {
      valid = false;
    }
    return valid;
  };

  const sendCode = (obj: RequestAddCodeUpdateSuscriptor) => {
    setIsLoading(true);
    sendCodeUpdateSuscriptor(obj, idCliente)
      .then((response) => {
        if (response.data.data[0].success) {
          setAskForCode(true);
          let dispatchAlert: AlertSliceInterface = {
            show: true,
            type: "SUCCESS",
            title: "¡Estimado Usuario!",
            message: response.data.data[0].message,
            onFinalize: () => handleDispatchAlertModal(null),
          };
          openAlertModal(dispatchAlert);
        } else {
          let dispatchAlert: AlertSliceInterface = {
            show: true,
            type: "ERROR",
            title: "¡Estimado Usuario!",
            message: response.data.data[0].message,
            onFinalize: () => handleDispatchAlertModal(null),
          };
          openAlertModal(dispatchAlert);
        }
      })
      .catch(() => {
        let dispatchAlert: AlertSliceInterface = {
          show: true,
          type: "ERROR",
          title: "¡Estimado Usuario!",
          message:
            "Hubo un error al procesar su solicitud. \nIntente más tarde.",
          onFinalize: () => handleDispatchAlertModal(null),
        };
        openAlertModal(dispatchAlert);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const validate = () => {
    let error = "";
    let errorFields: errorFieldsProps = {};

    let fieldToValidate = "";
    let valueToValidate = "";

    if (canUpdateEmail && canUpdatePhone) {
      // Si ambas opciones están disponibles, validamos la seleccionada
      if (selectedOption === "cellphone") {
        fieldToValidate = "cellphone";
        valueToValidate = cellphone;
      } else if (selectedOption === "email") {
        fieldToValidate = "email";
        valueToValidate = email;
      }
    } else if (canUpdatePhone) {
      // Solo el teléfono
      fieldToValidate = "cellphone";
      valueToValidate = cellphone;
    } else if (canUpdateEmail) {
      // Solo el email
      fieldToValidate = "email";
      valueToValidate = email;
    }

    // Aplicar validaciones basadas en el campo determinado
    if (fieldToValidate === "cellphone") {
      if (_.isEmpty(valueToValidate)) {
        const msg = "El campo Teléfono de contacto no puede estar vacío.\n";
        error += msg;
        errorFields.cellphoneNumber = msg;
      } else if (valueToValidate.length < 10) {
        const msg = "El campo Teléfono de contacto debe tener 10 dígitos.\n";
        error += msg;
        errorFields.cellphoneNumber = msg;
      }
    } else if (fieldToValidate === "email") {
      if (_.isEmpty(valueToValidate)) {
        const msg =
          "El campo Correo electrónico de contacto no puede estar vacío.\n";
        error += msg;
        errorFields.emailAddress = msg;
      } else if (!validateEmail(valueToValidate)) {
        const msg = "El formato del correo es inválido.\n";
        error += msg;
        errorFields.emailAddress = msg;
      }
    }

    setErrorsEmptyFields(errorFields);

    if (error !== "") {
      openAlertModal({
        show: true,
        type: "ERROR",
        title: "¡Estimado Usuario!",
        message: error,
        onFinalize: () => handleDispatchAlertModal(null),
      });
    } else {
      sendCode({
        email: canUpdateEmail ? email : "",
        phone: canUpdatePhone ? cellphone : "",
      });
    }
  };

  const update = () => {
    let error = "";
    let message = "";
    let errorFields: errorFieldsProps = {
      verificationCode: "",
    };

    if (code.length < 6) {
      message = "El campo Código de validación debe tener 6 dígitos.\n";
      error += message;
      errorFields.verificationCode = message;
    }

    setErrorsEmptyFields(errorFields);
    if (error !== "") {
      let dispatchAlert: AlertSliceInterface = {
        show: true,
        type: "ERROR",
        title: "¡Estimado Usuario!",
        message: error,
        onFinalize: () => handleDispatchAlertModal(null),
      };
      openAlertModal(dispatchAlert);
    } else {
      let objSendCode: RequestUpdateSuscriptor = {
        code: code,
      };

      setIsLoading(true);
      updateSuscriptor(objSendCode, idCliente)
        .then(async (response) => {
          if (response.data.data[0].success) {
            let additionalMessage = "";

            const unassociated = generalData.contracts.find(
              (item) => !item.isAssociatedContract,
            );

            if (unassociated) {
              let mainIdCliente = "";
              mainIdCliente = unassociated?.sucursal + unassociated?.suscriptor;

              if (mainIdCliente !== idCliente) {
                additionalMessage =
                  "\n Para aplicar los cambios, recargaremos la página. Esto te llevará de vuelta a tu contrato principal. \n Si estabas viendo otro contrato, puedes seleccionarlo nuevamente después de la recarga.";
              }
              await dispatch(
                fillGeneralDataSlice({
                  clientId: mainIdCliente,
                }),
              );
            }

            let dispatchAlert: AlertSliceInterface = {
              show: true,
              type: "SUCCESS",
              title: "¡Estimado Usuario!",
              message: response.data.data[0].message + additionalMessage,
              onFinalize: () => handleDispatchAlertModal("/settings"),
            };
            openAlertModal(dispatchAlert);
          } else {
            let dispatchAlert: AlertSliceInterface = {
              show: true,
              type: "ERROR",
              title: "¡Estimado Usuario!",
              message: response.data.data[0].message,
              onFinalize: () => handleDispatchAlertModal(null),
            };
            openAlertModal(dispatchAlert);
          }
        })
        .catch(() => {
          let dispatchAlert: AlertSliceInterface = {
            show: true,
            type: "ERROR",
            title: "¡Estimado Usuario!",
            message:
              "Hubo un error al procesar su solicitud. \nIntente más tarde.",
            onFinalize: () => handleDispatchAlertModal(null),
          };
          openAlertModal(dispatchAlert);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <SubDefaultLayout title={"Actualizar Datos de Contacto"}>
          <div style={styles.divRoot}>
            <Card style={styles.cardStyles}>
              <div style={{ padding: "15px 0px 20px 0px" }}>
                <InfoCardComponent
                  title="Aquí puede vincular a su cuenta de servicios en línea los datos de contacto en donde podrá recibir notificaciones."
                  description="Ingrese los datos de contacto."
                />
              </div>
              {askForCode ? (
                <>
                  <Row style={{ justifyContent: "center" }}>
                    <Col xs={24} xl={12}>
                      <Text style={styles.inputTitle}>
                        Código de validación
                      </Text>
                      <Input
                        placeholder="Código de validación"
                        value={code}
                        style={styles.inputText}
                        onChange={(event) =>
                          handleChangeCode(event.target.value)
                        }
                        maxLength={6}
                        status={
                          errorsEmptyFields.verificationCode ? "error" : ""
                        }
                      />
                      <Text type="danger" style={styles.emptyFieldError}>
                        {errorsEmptyFields.verificationCode
                          ? errorsEmptyFields.verificationCode
                          : null}
                      </Text>
                    </Col>
                  </Row>
                  <Row style={{ justifyContent: "center" }}>
                    <div style={styles.containerButtonAdd}>
                      <Button
                        size="large"
                        style={styles.buttonPrimary}
                        onClick={update}
                      >
                        Actualizar
                      </Button>
                    </div>
                  </Row>
                </>
              ) : (
                <>
                  {canUpdateEmail && canUpdatePhone ? (
                    <>
                      <div style={{ padding: "0px 0px 20px 0px" }}>
                        <Row style={{ justifyContent: "center" }}>
                          <Col xs={24} xl={12}>
                            <Text style={styles.inputTitle}>
                              Seleccione el dato que desea actualizar
                            </Text>
                            <Row style={{ justifyContent: "center" }}>
                              <Radio.Group
                                options={options}
                                defaultValue={selectedOption}
                                optionType="button"
                                buttonStyle="solid"
                                style={{ marginTop: 15, alignSelf: "center" }}
                                onChange={(event) =>
                                  handleOptionChange(event.target.value)
                                }
                              />
                            </Row>
                          </Col>
                        </Row>
                      </div>
                      <Row style={{ justifyContent: "center" }}>
                        {selectedOption === "cellphone" && (
                          <Col xs={24} xl={12}>
                            <Text style={styles.inputTitle}>
                              Teléfono de contacto
                            </Text>
                            <Input
                              placeholder="Teléfono de contacto"
                              value={cellphone}
                              style={styles.inputText}
                              onChange={(event) =>
                                handleChangePhone(event.target.value)
                              }
                              maxLength={10}
                              status={
                                errorsEmptyFields.cellphoneNumber ? "error" : ""
                              }
                            />
                            <Text type="danger" style={styles.emptyFieldError}>
                              {errorsEmptyFields.cellphoneNumber || ""}
                            </Text>
                          </Col>
                        )}
                        {selectedOption === "email" && (
                          <Col xs={24} xl={12}>
                            <Text style={styles.inputTitle}>
                              Correo electrónico
                            </Text>
                            <Input
                              placeholder="Correo electrónico"
                              value={email}
                              style={styles.inputText}
                              onChange={(event) =>
                                handleChangeEmail(event.target.value)
                              }
                              status={
                                errorsEmptyFields.emailAddress ? "error" : ""
                              }
                            />
                            <Text type="danger" style={styles.emptyFieldError}>
                              {errorsEmptyFields.emailAddress || ""}
                            </Text>
                          </Col>
                        )}
                      </Row>
                    </>
                  ) : (
                    <Row style={{ justifyContent: "center" }}>
                      {canUpdatePhone && (
                        <Col xs={24} xl={12}>
                          <Text style={styles.inputTitle}>
                            Teléfono de contacto
                          </Text>
                          <Input
                            placeholder="Teléfono de contacto"
                            value={cellphone}
                            style={styles.inputText}
                            onChange={(event) =>
                              handleChangePhone(event.target.value)
                            }
                            maxLength={10}
                            status={
                              errorsEmptyFields.cellphoneNumber ? "error" : ""
                            }
                          />
                          <Text type="danger" style={styles.emptyFieldError}>
                            {errorsEmptyFields.cellphoneNumber || ""}
                          </Text>
                        </Col>
                      )}
                      {canUpdateEmail && (
                        <Col xs={24} xl={12}>
                          <Text style={styles.inputTitle}>
                            Correo electrónico
                          </Text>
                          <Input
                            placeholder="Correo electrónico"
                            value={email}
                            style={styles.inputText}
                            onChange={(event) =>
                              handleChangeEmail(event.target.value)
                            }
                            status={
                              errorsEmptyFields.emailAddress ? "error" : ""
                            }
                          />
                          <Text type="danger" style={styles.emptyFieldError}>
                            {errorsEmptyFields.emailAddress || ""}
                          </Text>
                        </Col>
                      )}
                    </Row>
                  )}
                  <Row style={{ justifyContent: "center" }}>
                    <div style={styles.containerButtonAdd}>
                      <Button
                        size="large"
                        style={styles.buttonPrimary}
                        onClick={validate}
                      >
                        Continuar
                      </Button>
                    </div>
                  </Row>
                </>
              )}
            </Card>
          </div>
        </SubDefaultLayout>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  divRoot: {
    alignItems: "center",
    display: "flex",
    width: "100%",
    flexDirection: "column",
    marginTop: 20,
  },
  cardStyles: {
    marginBottom: 15,
    boxShadow: "0px 0px 8px #00000029",
    borderRadius: 15,
    width: "70%",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
  },
  addContract: {
    fontWeight: 600,
    color: "#757982",
    fontSize: 17,
  },
  colView: {
    display: "flex",
    justifyContent: "flex-end",
  },
  inputTitle: {
    color: "#0055c2",
    fontWeight: 600,
    fontSize: 12,
  },
  inputText: {
    marginTop: 15,
    color: "#000000",
    borderColor: "#000000",
    fontSize: 12,
  },
  emptyFieldError: {
    fontSize: 11,
  },
  containerButtonAdd: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 20,
  },
  buttonPrimary: {
    backgroundColor: "#0055c2",
    borderRadius: 30,
    color: "white",
    border: "none",
    padding: "5px 30px",
    height: 35,
  },
  iconStyles: {
    fontSize: 20,
    color: "#767a82",
  },
  imageStyle: {
    width: 200,
    height: 97,
  },
  iconInfo: {
    color: "rgba(0,0,0,.45)",
  },
});

export default UpdateSuscriptorData;
